export const BINDING_ATTRIBUTE = 'data-cmsv';
